import { Link } from '@mui/material';
import React, { useContext } from 'react';
import { DataContext, NavContext, NavRoutes } from '../contexts';

export const UtenteLink = ({ utenteId, ...props }) => {
    const { utenti } = useContext(DataContext);
    const { getRouteTo } = useContext(NavContext);

    const utente = utenti && utenti.find(x => x.id == utenteId);
    const utenteLabel = utente && `${utente.nome} ${utente.cognome}`;

    return (
        <>
            {
                utenteLabel ?
                    <Link
                        color="textPrimary"
                        onClick={() => window.open(getRouteTo(NavRoutes.Utente, [utenteId]), "_blank").focus()}
                        sx={{ fontWeight: 700, cursor: "pointer", textAlign: 'center' }}>
                        {utenteLabel}
                    </Link>
                    :
                    '-'
            }
        </>
    );
}